// Copyright (c) Docugami, Inc. All rights reserved.

import { ReportLabels } from "components/reports/ReportsContext";
import { WorkPathType } from "networking/WorkPathApi";

export const useWorkPathTypeName = (workPathType: WorkPathType): string => {
    switch (workPathType) {
        case WorkPathType.Abstract:
        case WorkPathType.AssistedAuthoring:
        case WorkPathType.ExcelExport:
        case WorkPathType.TabularReport:
        case WorkPathType.DiligenceReport:
            return 'Project';
        case WorkPathType.AutomationAnywhereDocumentAssembly:
        case WorkPathType.AutomationAnywhereWorkFlow:
        case WorkPathType.PowerAutomateWorkFlow:
        case WorkPathType.UiPathDocumentAssembly:
        case WorkPathType.UiPathWorkFlow:
        case WorkPathType.ZapierWorkFlow:
            return 'Workflow';
        default:
            return 'Project';
    }
}

export const useWorkPathReportLabels = (workPathType: WorkPathType): ReportLabels => {
    switch (workPathType) {
        case WorkPathType.Abstract:
            return { titleName: 'Abstract', itemsName: 'Abstract' };
        case WorkPathType.ExcelExport:
            return { titleName: 'Excel Report', itemsName: 'Report' };
        case WorkPathType.DiligenceReport:
            return { titleName: 'Diligence Report', itemsName: 'Report' };
        case WorkPathType.TabularReport:
            return { titleName: 'Report', itemsName: 'Report' };
        case WorkPathType.AutomationAnywhereDocumentAssembly:
        case WorkPathType.UiPathDocumentAssembly:
            return { titleName: 'Document Assembly', itemsName: 'Assembly' };
        case WorkPathType.AutomationAnywhereWorkFlow:
        case WorkPathType.PowerAutomateWorkFlow:
        case WorkPathType.UiPathWorkFlow:
        case WorkPathType.ZapierWorkFlow:
            return { titleName: 'Workflow', itemsName: 'Workflow' };
        default:
            return { titleName: 'Project', itemsName: 'Project' };
    }
}

export const useWorkPathBrandName = (workPathType?: WorkPathType): string | undefined => {
    switch (workPathType) {
        case WorkPathType.AutomationAnywhereDocumentAssembly:
        case WorkPathType.AutomationAnywhereWorkFlow:
            return 'Automation Anywhere'
        case WorkPathType.UiPathDocumentAssembly:
        case WorkPathType.UiPathWorkFlow:
            return 'UiPath'
        case WorkPathType.PowerAutomateWorkFlow:
            return 'Power Automate'
        case WorkPathType.ZapierWorkFlow:
            return 'Zapier';
    }
}
